import { StyleSheet } from 'react-native';
import { themes } from 'src/theme/theme';

const styles = StyleSheet.create({
  welcomeDetailsContainer: {
    padding: 16,
    justifyContent: 'space-between',
    flexGrow: 1,
    backgroundColor: `#FFF`,
  },
  dataFieldsContainer: {
    flex: 1,
    gap: 24,
  },
  title: {
    marginBottom: 16,
    paddingVertical: 16,
  },
  data: {
    marginBottom: 12,
  },
  actionsContainer: {
    gap: 16,
    flexDirection: 'row',
    justifyContent: 'center',
    marginTop: 16,
  },
  fieldAndValueContainer: {},
  ///DisplayFields
  fieldContainer: {
    // marginBottom: 16,
  },
  label: {
    marginBottom: 16,
    color: themes.light.gray_blue[3],
  },
  fieldValue: {
    borderWidth: 1,
    borderColor: themes.light.gray_blue[6],
    paddingVertical: 18,
    paddingHorizontal: 10,
    borderRadius: 8,
  },
  buttonContainer: {
    flexDirection: 'row',
    justifyContent: 'space-between', // Space between buttons
    gap: 8,
    width: '100%',
    paddingVertical: 12,
    paddingHorizontal: 12,
  },
  buttonWrapper1: {
    flex: 1, // Allow it to grow
    maxWidth: '33%', // Restrict to 33% width
  },
  buttonWrapper2: {
    flex: 1, // Allow it to grow
    maxWidth: '67%', // Restrict to 67% width
  },

  fieldsContainer: {
    gap: 10,
  },
});

export default styles;
